import GetJurisdictions from '../api/GetJurisdictions';

const requestJurisdictionType = 'REQUEST_JURISDICTION';
const receiveJurisdictionType = 'RECEIVE_JURISDICTION';
const initialState = {
    isLoading: false,
    all: []
};

export const actionCreators = {
    requestJurisdictions: (state) => async (dispatch, getState) => {
        if (getState().jurisdictions.isLoading)
            return;

        dispatch({ type: requestJurisdictionType });

        GetJurisdictions(state).then(data => {
            dispatch({ type: receiveJurisdictionType, data });
        }).catch(ex => {
            dispatch({ type: receiveJurisdictionType, ...initialState, errorMessage: "A server error has occurred. Error Code #1." })
        });
    },
};

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === requestJurisdictionType) {
        return {
            ...state,
            isLoading: true
        };
    }

    if (action.type === receiveJurisdictionType) {
        return {
            ...state,
            all: action.data != null && typeof action.data[Symbol.iterator] === 'function'  && [...action.data] || [],
            isLoading: false
        };
    }

    return state;
};